"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _framerMotion = require("framer-motion");

var _Modal = require("./Modal.style");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _warning = _interopRequireDefault(require("../Icon/Icons/warning"));

var _checked = _interopRequireDefault(require("../Icon/Icons/checked"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var rootModal = document.body;

var TypeWarning = function TypeWarning(_ref) {
  var content = _ref.content;
  var title = content.title,
      description = content.description,
      _content$hint = content.hint,
      hint = _content$hint === void 0 ? null : _content$hint,
      _content$primaryButto = content.primaryButtonLabel,
      primaryButtonLabel = _content$primaryButto === void 0 ? 'Confirm' : _content$primaryButto,
      _content$secondaryBut = content.secondaryButtonLabel,
      secondaryButtonLabel = _content$secondaryBut === void 0 ? 'Cancel' : _content$secondaryBut,
      onClose = content.onClose,
      onConfirm = content.onConfirm;
  return _react["default"].createElement("div", null, _react["default"].createElement(_Modal.ModalTitle, null, _react["default"].createElement(_warning["default"], {
    height: "21",
    width: "19",
    viewBox: "0 0 14 13"
  }), _react["default"].createElement("span", null), _react["default"].createElement("div", {
    className: "title"
  }, title)), _react["default"].createElement(_Modal.ModalDescription, {
    descriptionPadding: "6"
  }, _react["default"].createElement("div", {
    className: "description"
  }, description), hint && _react["default"].createElement("div", {
    className: "hint"
  }, hint)), _react["default"].createElement(_Modal.ModalActions, null, _react["default"].createElement(_Button["default"], {
    btnStyle: "borderlessSubtle",
    onClick: onClose
  }, secondaryButtonLabel), _react["default"].createElement(_Modal.Spacing, {
    width: 10
  }), _react["default"].createElement(_Button["default"], {
    btnStyle: "danger",
    onClick: onConfirm
  }, primaryButtonLabel)));
};

var TypeConfirm = function TypeConfirm(_ref2) {
  var content = _ref2.content;
  var title = content.title,
      description = content.description,
      _content$primaryButto2 = content.primaryButtonLabel,
      primaryButtonLabel = _content$primaryButto2 === void 0 ? 'Confirm' : _content$primaryButto2,
      _content$secondaryBut2 = content.secondaryButtonLabel,
      secondaryButtonLabel = _content$secondaryBut2 === void 0 ? 'Cancel' : _content$secondaryBut2,
      onClose = content.onClose,
      onConfirm = content.onConfirm;
  return _react["default"].createElement("div", null, _react["default"].createElement(_Modal.ModalTitle, {
    titleColor: "#212121"
  }, _react["default"].createElement("div", {
    className: "title"
  }, title)), _react["default"].createElement(_Modal.ModalDescription, {
    descriptionFontSize: "16"
  }, _react["default"].createElement("div", {
    className: "description"
  }, description)), _react["default"].createElement(_Modal.ModalActions, null, _react["default"].createElement(_Button["default"], {
    btnStyle: "borderlessSubtle",
    onClick: onClose
  }, secondaryButtonLabel), _react["default"].createElement(_Modal.Spacing, {
    width: 10
  }), _react["default"].createElement(_Button["default"], {
    btnStyle: "primary",
    onClick: onConfirm
  }, primaryButtonLabel)));
};

var TypeSuccess = function TypeSuccess(_ref3) {
  var content = _ref3.content;
  var title = content.title;
  return _react["default"].createElement("div", null, _react["default"].createElement(_Modal.ModalSuccessIcon, null, _react["default"].createElement(_checked["default"], {
    width: "75",
    height: "75",
    viewBox: "0 0 14 14"
  })), _react["default"].createElement(_Modal.ModalSuccessMessage, null, title));
};

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (e) {
      if (e.type === 'click' && e.target !== _this.modalRef && !_this.modalRef.current.contains(e.target) || e.type === 'keydown' && e.keyCode === 27) {
        _this.props.onClose(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "typeNone", function () {
      var children = _this.props.children;
      return {
        children: children
      };
    });

    _this.el = document.createElement('div');
    _this.modalRef = _react["default"].createRef();
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      rootModal.appendChild(this.el);
      document.body.style.overflowY = 'hidden';
      window.addEventListener('keydown', this.closeModal);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      rootModal.removeChild(this.el);
      document.body.style.overflowY = null;
      window.removeEventListener('keydown', this.closeModal);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          children = _this$props.children,
          onClose = _this$props.onClose,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? 'none' : _this$props$type;
      return _reactDom["default"].createPortal(_react["default"].createElement(_framerMotion.motion.div, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1,
          transition: {
            duration: 0.15
          }
        },
        exit: {
          opacity: 0,
          transition: {
            duration: 0.15
          }
        }
      }, _react["default"].createElement(_focusTrapReact["default"], {
        role: "dialog"
      }, _react["default"].createElement(_Modal.StyleBase, {
        onClick: this.closeModal
      }, _react["default"].createElement(_framerMotion.motion.div, {
        initial: {
          opacity: 0,
          scale: 0.8
        },
        animate: {
          opacity: 1,
          scale: 1,
          transition: {
            delay: 0.15,
            duration: 0.15
          }
        }
      }, _react["default"].createElement(_Modal.ModalContent, {
        ref: this.modalRef,
        width: width
      }, type === 'none' && children, type === 'warning' && _react["default"].createElement(TypeWarning, {
        content: this.props
      }), type === 'confirm' && _react["default"].createElement(TypeConfirm, {
        content: this.props
      }), type === 'success' && _react["default"].createElement(TypeSuccess, {
        content: this.props
      }), _react["default"].createElement(_Modal.CloseBtn, {
        ariaLabel: "Close",
        onClick: onClose
      }, _react["default"].createElement("svg", {
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("path", {
        d: "M1.6 1.6l12.914 12.914M14.514 1.6L1.6 14.514",
        stroke: "#2D2D2D",
        strokeWidth: "2.4"
      }))))))))), this.el);
    }
  }]);

  return Modal;
}(_react["default"].Component);

Modal.propTypes = {
  type: _propTypes["default"].string,
  width: _propTypes["default"].number,
  children: _propTypes["default"].any,
  onClose: _propTypes["default"].func.isRequired
};
TypeWarning.propTypes = {
  content: _propTypes["default"].object
};
TypeConfirm.propTypes = {
  content: _propTypes["default"].object
};
TypeSuccess.propTypes = {
  content: _propTypes["default"].object
};
var _default = Modal;
exports["default"] = _default;